import React from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getNotificationsTabs } from '../../../../constants'

import { selectRole } from '../../../../routing/fetchingfunction/user/user.reducer'

const Notifications = () => {
  const location = useLocation()

  const role = useSelector(selectRole)

  const notificationsTabsContent = getNotificationsTabs(role).map((tab) => {
    const isActive = tab.exact
      ? location.pathname === tab.link
      : location.pathname.includes(tab.link)

    return (
      <Link
        key={tab.label}
        to={tab.link}
        className={`relative text-md  sm:text-2xl text-primary-100 hover:text-primary-100 pb-[16px] transition-opacity duration-200 ease after:absolute after:h-[4px] after:w-full after:bottom-0 after:left-0 after:transition-colors after:duration-200 after:ease ${
          isActive
            ? 'after:bg-primary-100 font-bold'
            : 'after:bg-transparent font-medium opacity-70'
        }`}
      >
        {tab.label}
      </Link>
    )
  })

  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Notification Settings
      </h3>

      <div className="mt-[20px] bg-[#FEEBDD] rounded-[10px] p-[32px]">
        <div className="w-full flex items-center gap-x-[32px] mb-[20px]">
          {notificationsTabsContent}
        </div>

        <Outlet />
      </div>
    </div>
  )
}

export default Notifications
